import { useState } from 'react'
import ReactPlayer from 'react-player'

import LinkButton from '@components/LinkButton'
import Notification from '@components/Notification'
import BlockLayout from './BlockLayout'
import BlockActions from './BlockActions'
import { useUpdateBlockSubmission } from './hooks'

const VideoBlock = ({
  url,
  moveToNextBlock,
  moveToPreviousBlock,
  isFirstBlock,
  isLastBlock,
  isSubmissionClosed,
  openSubmitModal,
  submissionStatus,
  submissionId,
  blockId
}) => {
  const [videoErrored, setVideoErrored] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { updateBlockSubmission } = useUpdateBlockSubmission({ educatorProjectSubmissionId: submissionId })

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Don't mark as completed if already completed/returned or submission is closed
    if (submissionStatus === 'COMPLETED' || submissionStatus === 'RETURNED' || isSubmissionClosed) {
      if (isLastBlock) {
        openSubmitModal();
      } else {
        moveToNextBlock();
      }
      return;
    }

    setIsSubmitting(true);

    try {
      await updateBlockSubmission({ blockId, status: 'COMPLETED' });

      if (isLastBlock) {
        openSubmitModal();
      } else {
        moveToNextBlock();
      }
    } catch (error) {
      console.error('Error updating block submission:', error);
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleBack = () => {
    moveToPreviousBlock()
  }

  return (
    <form onSubmit={handleSubmit}>
      <BlockLayout>
        <BlockLayout.Actions>
          <BlockActions
            isFirstBlock={isFirstBlock}
            isLastBlock={isLastBlock}
            onBack={handleBack}
            isSubmissionClosed={isSubmissionClosed}
            submissionStatus={submissionStatus}
            isSubmitting={isSubmitting}
            tooltipText="Submissions are closed for this pathway"
          />
        </BlockLayout.Actions>
        <BlockLayout.Content>
          {videoErrored ? (
            <Notification className='w-fit' theme='error'>
              Oops! Something went wrong while loading your video.
            </Notification>
          ) : url ? (
            <div className='flex justify-center'>
              <div className='w-full max-w-3xl aspect-video'>
                <ReactPlayer
                  width='100%'
                  height='100%'
                  controls
                  url={url}
                  onError={() => setVideoErrored(true)}
                  className='bg-muted'
                />
              </div>
            </div>
          ) : null}
        </BlockLayout.Content>
      </BlockLayout>
    </form>
  )
}

export default VideoBlock
